import React from "react";
import style from "./style.module.css";

export default function Avatar(props) {
  const { username } = props;

  let name = username;
  let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");
  let initials = [...name.matchAll(rgx)] || [];
  initials = ((initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")).toUpperCase();

  return (
    <div {...props}>
      <div className={style.container}>
        <span className={style.initials} translate="no">
          {initials || "?"}
        </span>
      </div>
    </div>
  );
}
